import { DateTime } from 'luxon';
import isBeforeDay from './isBeforeDay';

export default function isInclusivelyAfterDay(a, b) {
  if (!(a instanceof DateTime) || !(b instanceof DateTime)) return false;
  
  
  return !isBeforeDay(a, b);
}
